export default __webpack_public_path__ + "static/media/Victory.9dc0cacb.png";